import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "upload-box"
};
const _hoisted_2 = {
  class: "description-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_version_list = _resolveComponent("version-list");
  const _component_ide_upload = _resolveComponent("ide-upload");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_app_upload = _resolveComponent("app-upload");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_version_list, {
    type: $setup.actived,
    version: $setup.versionData
  }, null, 8, ["type", "version"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("h1", null, _toDisplayString(_ctx.$t("message.hcDownload")), 1), _createVNode(_component_el_tabs, {
    modelValue: $setup.actived,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.actived = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "IDE",
      name: "IDE"
    }, {
      default: _withCtx(() => [_createVNode(_component_ide_upload, {
        ide: $setup.ideUpload
      }, null, 8, ["ide"])]),
      _: 1
    }), _createVNode(_component_el_tab_pane, {
      label: "APP",
      name: "APP"
    }, {
      default: _withCtx(() => [_createVNode(_component_app_upload, {
        app: $setup.appUpload
      }, null, 8, ["app"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])]);
}